import React, { memo } from 'react';
import { cn } from '@/lib/utils';

const MAX_DISPLAYED_COUNT = 99;

interface NotificationBadgeProps {
    count: number
    className?: string
}

/** Unread-count pill. Sighted users see a capped number; screen readers get the real one. */
const NotificationBadge: React.FC<NotificationBadgeProps> = ({ count, className }) => {
    if (count <= 0) return null;

    return (
        <>
            <span
                aria-hidden="true"
                className={cn(
                    'inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white',
                    className
                )}
            >
                {count > MAX_DISPLAYED_COUNT ? `${MAX_DISPLAYED_COUNT}+` : count}
            </span>
            {/* Leading comma keeps the accessible name readable: "Notifications, 3 unread". */}
            <span className="sr-only">{`, ${count} unread`}</span>
        </>
    );
};

export default memo(NotificationBadge);
